import Vue from "vue"
import Vuex from "vuex"

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		sharedData: localStorage.getItem('updateSharedData') || {}
	},
	mutations: {
		setSharedData(state, newData) {
			state.sharedData = newData;
			localStorage.setItem('updateSharedData', newData)
		}
	},
	actions: {
		updateSharedData({ commit }, newData) {
			commit('setSharedData', newData);
		}
	},
	getters: {
		getSharedData(state) {
			return state.sharedData;
		}
	}
});